import React, { useEffect, useState } from 'react'
import { Panel, Table, Checkbox } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { CANCEL, DEFAULT_ERR_MSG, SAVE, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import notification from '../../utils/notification'
import { cloneDeep } from 'lodash-es'
import { saveMainMenuPermission } from '../../redux/actions/adminProjectManagemant'

export default function ManageMainMenuPermissionsWidget({ schema: _schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [isShowConfirm, setIsShowConfirm] = useState()
  const [request, setRequest] = useState()
  const [masterData, setMasterData] = useState()
  const [masterDataTemp, setMasterDataTemp] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handleGenMasterData(_schema?.values || [])
  }, [_schema])

  const handleGenMasterData = (values) => {
    var map = new Map()

    values?.forEach((item) => {
      map.set(item.menuCode, item.roles || [])
    })

    setMasterData(map)
    setMasterDataTemp(map)
  }

  const handleSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsShowConfirm(false)
    try {
      const response = await saveMainMenuPermission(request)

      if (response?.model) {
        handleGenMasterData(response.model.values || [])

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      // console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onChangePermission = (menuCode, role, checked, index) => {
    //console.log('ROLE : ', role, ', index : ', index, ' ', checked)

    let dataMap = cloneDeep(masterData)

    let enableRole = dataMap.get(menuCode) || []

    if (checked) {
      enableRole.push(role)
    } else {
      enableRole = enableRole.filter((e) => e != role)
    }

    enableRole = [...new Set(enableRole)]

    dataMap.set(menuCode, enableRole)

    setMasterData(dataMap)
  }

  const onSubmit = () => {
    let requestDatas = []

    for (let [key, value] of masterData) {
      requestDatas.push({ menuCode: key, roles: value })
    }

    let req = {
      requestData: requestDatas,
    }

    console.log('req : ', req)

    setRequest(req)
    setIsShowConfirm(true)
  }

  const onCancel = () => {
    setRequest({})
    setMasterData(masterDataTemp)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {formSchema && (
        <Panel shaded header={formSchema.header} collapsible defaultExpanded>
          <Table
            wordWrap
            height={450}
            loading={isLoading}
            data={formSchema?.values || []}
            style={{ marginTop: '20px' }}
          >
            <Column align="center" width={100} fixed>
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>
            <Column width={160} fixed>
              <HeaderCell>ระบบงานย่อย</HeaderCell>
              <Cell dataKey={'menuName'} />
            </Column>

            {formSchema.roles.map((item) => {
              return (
                <Column minWidth={150} flexGrow={1} align="center">
                  <HeaderCell>{item}</HeaderCell>
                  <Cell>
                    {(rowData, index) => {
                      return (
                        <div style={{ textAlign: 'center', width: '100%' }}>
                          <Checkbox
                            //defaultChecked={rowData?.roles.includes(item)}
                            checked={masterData?.get(rowData.menuCode)?.includes(item)}
                            disabled={rowData?.disabled}
                            onChange={(value, checked) => {
                              onChangePermission(rowData.menuCode, item, checked, index)
                            }}
                            style={{ marginLeft: '30%' }}
                          />
                        </div>
                      )
                    }}
                  </Cell>
                </Column>
              )
            })}
          </Table>
          <div style={{ marginTop: 20 }}>
            <SaveButton onClick={onSubmit}>{SAVE}</SaveButton>
            <CancelButton onClick={onCancel}>{CANCEL}</CancelButton>
          </div>
        </Panel>
      )}

      <ConfirmWidget
        title={`ยืนยัน`}
        show={isShowConfirm}
        detail={`ยืนยันการบันทึก/แก้ไข ${formSchema.header || ''}`}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={() => handleSave(request)}
      />
    </>
  )
}
